import React, { useEffect, useRef } from 'react';
import VanNotFound from '../../_styles/images/new-icons/vanNotFound.svg';
import Close from '../../_styles/images/close-icon-green.svg';
import analyticsService from '../../shared/analytics/analytics-service';
import Callable from '../../shared/Callable';


export default function TerminatedVanpool(props) {
    const node = useRef();

    function updatTVPKeydown(e) {
        if (e.which === 13) {
            props.updateTVPopup(false)
        }
    }

    const close = (e) => {
        if (e.keyCode === 27) {
            const changesPopup = document.getElementById('preferred-vanpool-popup');
            if (changesPopup) {
                props.updateTVPopup(false);
            }
        }
    }

    useEffect(() => {
        analyticsService.analyticsProcessEvent({
            "event": "modal_view_generic",
            "context": {
                "event_action": "vanpool is no longer available modal"
            }
        })
        document.querySelector('.preferred-container') && document.querySelector('.preferred-container').focus();
        document.querySelector('.update-commute') && document.querySelector('.update-commute').setAttribute('aria-hidden', 'true');
        document.querySelector('.exactMatch') && document.querySelector('.exactMatch').setAttribute('aria-hidden', 'true');
        document.querySelector('.matched-van-container') && document.querySelector('.matched-van-container').setAttribute('aria-hidden', 'true');
        window.addEventListener('keydown', close);
        return () => {
            window.removeEventListener('keydown', close);
            document.querySelector('.update-commute') && document.querySelector('.update-commute').setAttribute('aria-hidden', 'false');
            document.querySelector('.exactMatch') && document.querySelector('.exactMatch').setAttribute('aria-hidden', 'false');
            document.querySelector('.matched-van-container') && document.querySelector('.matched-van-container').setAttribute('aria-hidden', 'false');
        }
    }, [])

    return (
        <div className="charges-popup show" id='preferred-vanpool-popup' aria-live='polite' role='alert' aria-modal='true' ref={node}>
            <div className='preferred-container'>
                <div className="preferred-vanpool-container">
                    <div className='top-header'>
                        <button
                            role='button'
                            className="close traditional"
                            onClick={() => props.updateTVPopup(false)}
                            onKeyDown={updatTVPKeydown}
                            tabIndex={0}
                            aria-label="Close popup"
                        >
                            <img src={Close} alt='Close' />
                        </button>

                    </div>
                    <div className="sp-header">

                        <div className='header'>
                            <div className='van-image'>
                                <img src={VanNotFound} alt='van not found' />
                            </div>
                            <div className='heading'>
                            The vanpool you were invited to is no longer available
                            </div>
                        </div>
                    </div>
                    <div className='preferred-vanpool-popup-container'>
                        <div className='content no-preferred-content'>
                            <div className='first-section'>
                            With new routes added daily, we can help you find a new suitable commute for your needs.</div>
                        </div>
                        <div className='footer'>
                            <div className='help'>
                            Need help?
                            </div>
                            <div className="pre-text">
                            If you need assistance please contact 
                            </div>
                            <Callable className="greentext" phone="800 VAN 4 WORK" />
                      
                        </div>
                    </div>
                    <div className='button-container'>
                        <button tabIndex={0} className='continue-button no-preferred' onClick={() => props.updateTVPopup(false)} onKeyDown={updatTVPKeydown}>find a new route</button>
                    </div>

                </div>
            </div>
        </div>
    );
}
